import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { ChatAgreementComponent } from '../chat-agreement/chat-agreement.component';
import { CalculateFileOperationService } from 'src/app/shared/services/calculate-file-operation.service';
import { ChatCadViewerComponent } from '../chat-cad-viewer/chat-cad-viewer.component';
import { AdminService } from 'src/app/admin/admin.service';

interface DialogData {
  data: string,
  bid_id?: any,
  bid_selection_id?: any
  endpoint?: string
  enquiry_id?: any
  showAgreement?: boolean
  customer?: string
  total_parts?: number
  total_batches?: number
  currency?: string
  iFrame3DPayload?: any
}

@Component({
  selector: 'app-engage-integration',
  templateUrl: './engage-integration.component.html',
  styleUrls: ['./engage-integration.component.scss']
})
export class EngageIntegrationComponent implements OnInit {

  engageUrl: any;
  chat_id: any;
  engage_token: any;
  loading: boolean = true; // Initially show loading overlay
  enquiry_id: any;
  iframeEndpoint = "dashboard/chat/liveChat/";
  agreementDialogOpened = false;
  constructor(public dialogref: MatDialogRef<EngageIntegrationComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private sanitizer: DomSanitizer, 
    private toastr: ToastrService,
    private calculateService: CalculateFileOperationService,
    private adminService:AdminService) {
    this.engage_token = localStorage.getItem('engage_auth_code')
  }

  ngOnInit(): void {
    this.loading = true;
    this.chat_id = this.data["data"]
    if (this.data["endpoint"]) {
      this.iframeEndpoint = this.data["endpoint"];
    }
    if (this.chat_id == '' || !this.chat_id) {
      this.close()
      this.toastr.info('The chat is not Initiated by Admin', 'Info');
    }
    else {
      this.engageUrl = this.getSafeUrl(this.chat_id, this.engage_token, this.iframeEndpoint)
    }

    // receive the quotation_id from bidding details component
    this.enquiry_id = this.data?.enquiry_id

    const engageCADPartSelectListener = (event: MessageEvent) => {
      this.handleMessage(event.data);
    };

    // Create the event listener
    const engageAgreementListener = (event: MessageEvent) => {
      // Regular expression to match the allowed origins
      const allowedOrigins =
        /^(https?:\/\/)?([a-zA-Z0-9-]+\.)?(engage)\.truventor\.(com|ai)$/;
      if (allowedOrigins.test(event.origin)) {
        console.log("Message received from App Two:", event.data);
        if(event.data.action === "agreement-viewer"){
          if(!this.agreementDialogOpened){
            this.openAgreementDialogNew();
          }
          this.agreementDialogOpened = !this.agreementDialogOpened;
        }
        else if(event?.data?.cleanedModelId || event.data.action === "cad-viewer"){
          engageCADPartSelectListener(event)
        }
      }
      
    };
    // Add the event listener
    window.addEventListener("message", engageAgreementListener, false);
  }

  getSafeUrl(chat_id: any, engage_token: string, endpoint: string) {
    if (chat_id) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(
        environment.safeUrl +
        endpoint +
        chat_id +
        "?token=" +
        engage_token +
        "&iframe=true"
      );
    } else {
      return this.sanitizer.bypassSecurityTrustResourceUrl(
        environment.safeUrl +
        endpoint +
        "?token=" +
        engage_token +
        "&iframe=true"
      );
    }
  }

  close() {
    this.dialogref.close()
  }

  handleMessage(data: any) {
    this.adminService.navigateToCalculate(data?.cleanedModelId);
    return;
    this.calculateService.generateCadUrl(data?.cleanedModelId).then(res => {
      // TODO: opening it in iframe isn't working for some reason, hence opening it in new tab for now
      window.open(res,
        "_blank"
      );
      // this.openChatCADViewerDialogNew(res)
      // this.chatChatViewerComponent.show(res);
      // this.cdRef.detectChanges();
    });
  }

  openChatCADViewerDialogNew(design_url:string){
    this.dialog.open(ChatCadViewerComponent, {
      panelClass: ["my-panel", "animate__animated", "animate__slideInLeft"],
      disableClose: true,
      data: {
        url: design_url,
      }
    });
  }

  openAgreementDialogNew() {
    this.dialog.open(ChatAgreementComponent, {
      panelClass: ["my-panel", "animate__animated", "animate__slideInLeft"],
      disableClose: true,
      height:'90vh',
      width:'70vw',
      data: {
        bid_selection_id: this.data?.bid_selection_id,
        total_parts: this.data?.total_parts,
        total_batches: this.data.total_batches,
        enquiry_id: this.data?.enquiry_id,
        customer:this.data?.customer,
        currency:this.data?.currency
      }
    });
  }

  onIframeLoad(iframeRef: HTMLIFrameElement) {
    if (iframeRef?.src !== "") {
      this.loading = false;
    }
    // iframeRef.contentWindow?.postMessage(
    //   "agreement",
    //   environment.safeUrl
    // );
    if(this.data?.showAgreement){
      iframeRef.contentWindow?.postMessage(
        {
          cleanedModelData : this.data?.iFrame3DPayload,
          type : "agreement",
        },
        environment.safeUrl
      );
    }
    else if(this.data?.iFrame3DPayload?.length > 0){
      iframeRef.contentWindow?.postMessage(
        {
          cleanedModelData : this.data?.iFrame3DPayload,
        },
        environment.safeUrl
      );
    }
  }

}
